/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonaleRapportinoDTO
 */
export interface PersonaleRapportinoDTO {
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoDTO
     */
    idPersonale?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonaleRapportinoDTO
     */
    personale?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoDTO
     */
    dataDaMattino?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoDTO
     */
    dataAMattino?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoDTO
     */
    dataDaPomeriggio?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoDTO
     */
    dataAPomeriggio?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoDTO
     */
    oreTotali?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoDTO
     */
    oreViaggio?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoDTO
     */
    viaggio?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoDTO
     */
    pernottamenti?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoDTO
     */
    dataIntervento?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoDTO
     */
    idCommessa?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PersonaleRapportinoDTO
     */
    commessa?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonaleRapportinoDTO
     */
    descrizioneCommessa?: string | null;
}

/**
 * Check if a given object implements the PersonaleRapportinoDTO interface.
 */
export function instanceOfPersonaleRapportinoDTO(value: object): value is PersonaleRapportinoDTO {
    return true;
}

export function PersonaleRapportinoDTOFromJSON(json: any): PersonaleRapportinoDTO {
    return PersonaleRapportinoDTOFromJSONTyped(json, false);
}

export function PersonaleRapportinoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonaleRapportinoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'personale': json['personale'] == null ? undefined : json['personale'],
        'dataDaMattino': json['dataDaMattino'] == null ? undefined : (new Date(json['dataDaMattino'])),
        'dataAMattino': json['dataAMattino'] == null ? undefined : (new Date(json['dataAMattino'])),
        'dataDaPomeriggio': json['dataDaPomeriggio'] == null ? undefined : (new Date(json['dataDaPomeriggio'])),
        'dataAPomeriggio': json['dataAPomeriggio'] == null ? undefined : (new Date(json['dataAPomeriggio'])),
        'oreTotali': json['oreTotali'] == null ? undefined : json['oreTotali'],
        'oreViaggio': json['oreViaggio'] == null ? undefined : json['oreViaggio'],
        'viaggio': json['viaggio'] == null ? undefined : json['viaggio'],
        'pernottamenti': json['pernottamenti'] == null ? undefined : json['pernottamenti'],
        'dataIntervento': json['dataIntervento'] == null ? undefined : (new Date(json['dataIntervento'])),
        'idCommessa': json['idCommessa'] == null ? undefined : json['idCommessa'],
        'commessa': json['commessa'] == null ? undefined : json['commessa'],
        'descrizioneCommessa': json['descrizioneCommessa'] == null ? undefined : json['descrizioneCommessa'],
    };
}

export function PersonaleRapportinoDTOToJSON(json: any): PersonaleRapportinoDTO {
    return PersonaleRapportinoDTOToJSONTyped(json, false);
}

export function PersonaleRapportinoDTOToJSONTyped(value?: PersonaleRapportinoDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idPersonale': value['idPersonale'],
        'personale': value['personale'],
        'dataDaMattino': value['dataDaMattino'] == null ? undefined : ((value['dataDaMattino'] as any).toISOString()),
        'dataAMattino': value['dataAMattino'] == null ? undefined : ((value['dataAMattino'] as any).toISOString()),
        'dataDaPomeriggio': value['dataDaPomeriggio'] == null ? undefined : ((value['dataDaPomeriggio'] as any).toISOString()),
        'dataAPomeriggio': value['dataAPomeriggio'] == null ? undefined : ((value['dataAPomeriggio'] as any).toISOString()),
        'oreTotali': value['oreTotali'],
        'oreViaggio': value['oreViaggio'],
        'viaggio': value['viaggio'],
        'pernottamenti': value['pernottamenti'],
        'dataIntervento': value['dataIntervento'] == null ? undefined : ((value['dataIntervento'] as any).toISOString()),
        'idCommessa': value['idCommessa'],
        'commessa': value['commessa'],
        'descrizioneCommessa': value['descrizioneCommessa'],
    };
}

